import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { db } from "../LoginComp/firebase";
import { collection, addDoc, getDocs } from "firebase/firestore";

import 'react-big-calendar/lib/css/react-big-calendar.css';
import "./arama-poojava.css";

const localizer = momentLocalizer(moment);

function AramaPoojava() {
const [isSubmitting, setIsSubmitting] = useState(false);

  const images = ['Uththama arama.png'];
      const [currentImageIndex, setCurrentImageIndex] = useState(0);
    
      useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change image every 3 seconds
    
        return () => clearInterval(interval); // Cleanup on unmount
      }, []);
    


const [currentDate, setCurrentDate] = useState(new Date());
  const [bookedDates, setBookedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: ""
  });

  // Load booked dates from Firebase
  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    const querySnapshot = await getDocs(collection(db, "aramapoojava"));
    const dates = querySnapshot.docs.map(doc => doc.data().date);
    setBookedDates(dates);
  };

  // Banner slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // date click
//   const handleDateSelect = (slotInfo) => {
//     const dateStr = moment(slotInfo.start).format("YYYY-MM-DD");

//     if (bookedDates.includes(dateStr)) {
//       alert("❌ This date already booked!");
//       return;
//     }

//     setSelectedDate(dateStr);
//     setShowForm(true);
//   };

const handleDateSelect = (slotInfo) => {
  const selected = moment(slotInfo.start).startOf("day");
  const today = moment().startOf("day");

  // // BLOCK PAST DATES
  // if (selected.isBefore(today)) {
  //   alert("❌ You cannot book past dates!");
  //   return;
  // }

  const dateStr = selected.format("YYYY-MM-DD");

  // BLOCK ALREADY BOOKED
  if (bookedDates.includes(dateStr)) {
    alert("❌ This date already booked!");
    return;
  }

  setSelectedDate(dateStr);
  setShowForm(true);
};













  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // SAVE TO FIREBASE
const handleSubmit = async (e) => {
  e.preventDefault();

  // PREVENT DOUBLE SUBMIT
  if (isSubmitting) return;

  setIsSubmitting(true);

  try {
    await addDoc(collection(db, "aramapoojava"), {
      ...formData,
      date: selectedDate,
      createdAt: new Date()
    });

    alert("✅ Booking saved successfully!");

    setBookedDates([...bookedDates, selectedDate]);
    setShowForm(false);

    setFormData({
      name: "",
      phone: "",
      email: "",
      address: ""
    });

  } catch (err) {
    alert("❌ Error saving booking");
    console.error(err);
  } finally {
    setIsSubmitting(false); // ALWAYS RESET
  }
};




  const dayStyleGetter = (date) => {
    const dateStr = moment(date).format("YYYY-MM-DD");

    if (bookedDates.includes(dateStr)) {
      return {
        className: 'booked-day'
      };
    }
    return {};
  };

  return (
        <>
    <div className="carousel">
      <div className="carousel-inner">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            className={`carousel-item ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))}
        

      </div>
    </div>

    <div className="appointment-container">

      <h2>Arama Poojava Booking</h2>


<Calendar
  localizer={localizer}
  date={currentDate}            // CONTROLLED
  onNavigate={(date) => setCurrentDate(date)} // <-- THIS FIXES IT
  defaultView="month"
  views={['month']}
  selectable
  onSelectSlot={handleDateSelect}
  dayPropGetter={dayStyleGetter}
  style={{ height: 450 }}
/>


      {/* FORM */}
 {/* FORM */}
{showForm && (
  <div className="ap-form-overlay">
    <div className="ap-form-card">

      <h3 className="ap-form-title">
        Booking for {selectedDate}
      </h3>

      <form onSubmit={handleSubmit} className="ap-form">

        <input
          type="text"
          name="name"
          placeholder="Full Name"
          required
          value={formData.name}
          onChange={handleChange}
          className="ap-input"
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          required
          value={formData.phone}
          onChange={handleChange}
          className="ap-input"
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          required
          value={formData.email}
          onChange={handleChange}
          className="ap-input"
        />

        <input
          type="text"
          name="address"
          placeholder="Home Address"
          required
          value={formData.address}
          onChange={handleChange}
          className="ap-input"
        />

        <div className="ap-form-actions">
<button
  type="submit"
  className="ap-btn ap-btn-primary"
  disabled={isSubmitting}
>
  {isSubmitting ? "Confirming..." : "Confirm Booking"}
</button>

          <button
            type="button"
            onClick={() => setShowForm(false)}
            className="ap-btn ap-btn-secondary"
          >
            Cancel
          </button>
        </div>

      </form>
    </div>
  </div>
)}


    </div>
    </>
  );
}

export default AramaPoojava;
